export default __webpack_public_path__ + "static/media/user.9cdd7248.png";